import React from "react";
import PropTypes from "prop-types";
import { css } from "@emotion/react";
import { colors, fontSize } from "style";
import Icon, { ICON_SIZE, ICON_TYPE } from "components/Icon";
import Tooltip from "components/Tooltip";

/**
 * ProfileAssignedIcon
 *
 * @param {Boolean} isAssigned
 */
const ProfileAssignedIcon = ({ isAssigned, ...props }) => {
  if (!isAssigned) return null;

  return (
    <Tooltip tooltipId="Profile.ProfileAssignedIcon.Tooltip" hideIcon>
      <div css={styles.container} {...props}>
        <div css={styles.icon_container}>
          <Icon type={ICON_TYPE.mentorship} size={ICON_SIZE.xlarge} />
        </div>
      </div>
    </Tooltip>
  );
};

const styles = {
  container: css`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0rem;
    color: ${colors.grayAnatomyLight1};
    font-size: ${fontSize.small};
    font-weight: 500;
  `,
  icon_container: css`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 3rem;
  `,
};

ProfileAssignedIcon.propTypes = {
  isAssigned: PropTypes.bool.isRequired,
};

export default ProfileAssignedIcon;
